const sizeChartBtn = document.querySelector('.u-cstm-size-chart-btn-wrapper');
const popup = document.getElementById('sizeChartPopup');
const closeBtn = document.getElementById('closePopup');
function openPopup() {
    popup.classList.add('show');
    document.body.style.overflow = 'hidden';
}
function closePopup() {
    popup.classList.remove('show');
    document.body.style.overflow = '';
}
sizeChartBtn.addEventListener('click', openPopup);
closeBtn.addEventListener('click', closePopup);
popup.addEventListener('click', function(e) {
    if (e.target === popup) {
        closePopup();
    }
});
document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && popup.classList.contains('show')) {
        closePopup();
    }
});